module.exports = __webpack_public_path__ + "static/media/kredyt_25.f6b0f6bd.png";